import { render, staticRenderFns } from "./AccionCopiarDocumento.vue?vue&type=template&id=3f2e0ae4&scoped=true&"
import script from "./AccionCopiarDocumento.vue?vue&type=script&lang=js&"
export * from "./AccionCopiarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./AccionCopiarDocumento.vue?vue&type=style&index=0&id=3f2e0ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e0ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2e0ae4')) {
      api.createRecord('3f2e0ae4', component.options)
    } else {
      api.reload('3f2e0ae4', component.options)
    }
    module.hot.accept("./AccionCopiarDocumento.vue?vue&type=template&id=3f2e0ae4&scoped=true&", function () {
      api.rerender('3f2e0ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionCopiarDocumento.vue"
export default component.exports